import { useMemo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { pagesEnum } from 'constants/ui.constants';
import { useAppSelector } from 'hooks/redux.hooks';
import { getIsDefaultPlan, getTerms, getUserPermission } from 'state/reducers/user.reducers';
import _ from 'lodash';
import { UserPermission } from 'constants/user.constants';
import { isLoading } from 'state/reducers/settings.reducers';
import { getLoadingApprovals } from 'state/reducers/global.reducers';

interface Props {
  component: any;
}

export default function ProtectedRoute(props: Props) {
  const agreedTerms = useAppSelector(getTerms);
  const isLoadingApprovals = useAppSelector(getLoadingApprovals)

  // const isDefaultPlan = useAppSelector(getIsDefaultPlan);
  // const userPermission = useAppSelector(getUserPermission);
  // const location = useLocation();

  // const redirectToPlans = useMemo(
  //   () =>
  //     isDefaultPlan &&
  //     [UserPermission.SIGNER].includes(userPermission) &&
  //     location.pathname !== `/${pagesEnum.PLANS}`,
  //   [location, isDefaultPlan]
  // );
  if(isLoadingApprovals) {
    return <></>;
  }
  
  if (!agreedTerms) {
    return <Navigate to={`/${pagesEnum.WELCOME}`} replace />;
  } 
 
  // else if (redirectToPlans) {
  //   return <Navigate to={`/${pagesEnum.PLANS}`} replace />;
  // }
  return props.component;
}
